module.exports = __webpack_public_path__ + "files/8175d0b5a4ee11c0ca206c7b8b7d82e5.png";